import { Shark } from "shark-mvc";
import moment from "moment";

import NousCoreModel from "./NousCoreModel";

class User extends NousCoreModel {
	static STATUS_ACTIVE = 1;
	static STATUS_INVITATION_PENDING = 2;
	static STATUS_DISABLED = 3;

	birthDate = "0000-00-00 00:00:00";
	enabled = true;
	email = "";
	
	extraData = {
		profilePicture: {
			thumbURL: "",
			url: "",
		},
	};

	firstName = "";
	lastLoginAt = "0000-00-00 00:00:00";
	lastName = "";
	notes = "";
	password = "";
	phone = "";
	tempKey = "";

	__activeCSSClass = "";
	__birthDate = "";
	__fullName = "";
	__passwordConfirm = "";
	__preserveLogin = true;
	__statusLabel = "";

	constructor (data) {
		super();

		// this.__allSlotList = {
		// 	today: [],
		// 	tomorrow: [],
		// };
		// this.__selected = false;

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = this.__export();//Dave: ma non sarebbe bello avere un metodo che prende lista di campi da includere e/o escludere?

		exportData.birthDate = this.exportDateField("birthDate");
		exportData.extraData = this.exportObjectField("extraData");

		if (this.password === "unchanged") {
			exportData.password = "";
		}

		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		if (this.importDateField("birthDate", data.birthDate)) {
			this.__birthDate = this.birthDate.format("YYYY-MM-DD");
			this.__birthDateLabel = this.birthDate.format("DD/MM/YYYY");
		}
		
		this.importNumberField("status", data.status);

		if (this.importDateField("lastLoginAt", data.lastLoginAt)) {
			this.__lastLoginAtLabel = this.lastLoginAt.format("DD/MM/YYYY - HH:mm");
		}

		this.__fullName = this.firstName + (this.lastName ? " " + this.lastName : "");
		this.password = "";
		this.__passwordConfirm = "";

		// this.parseStatus();
	}

	isValid (mode) {
		this.validate(mode);
		return this.__isValid;
	}

	on__birthDateChanged () {
		this.birthDate = moment(this.__birthDate);
		this.__birthDateLabel = this.birthDate.format("DD/MM/YYYY");
	}

	// parseStatus () {
	// 	this.__statusLabel = Shark.$store.userStatusMap.get(this.status);
	// }

	validate (mode) {
		const errors = [];
		this.__errors = {};
		this.__isValid = true;

		const eMailRegExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

		if (this.email.trim() === "" || !eMailRegExp.test(this.email.trim())) {
			this.__errors.email = true;
			this.__isValid = false;
		}

		if (mode === "register") {
			if (this.password.trim() === "") {
				this.__errors.password = true;
				this.__isValid = false;
			}
			if (this.password.trim() !== this.__passwordConfirm.trim()) {
				this.__errors.__passwordConfirm = true;
				this.__isValid = false;
			}
		}
		if (mode === "update") {
			if (this.password.trim() !== "" && this.password.trim() !== this.__passwordConfirm.trim()) {
				errors.push("La password di verifica non corrisponde.");
				this.__errors.__passwordConfirm = true;
				this.__isValid = false;
			}
		}
		
		if (mode === "login") {
			if (this.password.trim() === "") {
				this.__errors.password = true;
				this.__isValid = false;
			}
		}
		else if (mode !== "requestPasswordRecovery") {
			if (this.firstName.trim() === "") {
				this.__errors.firstName = true;
				this.__isValid = false;
			}

			// if (this.lastName.trim() === "") {
			// 	this.__errors.lastName = true;
			// 	this.__isValid = false;
			// }

			// if (mode !== "register" && this.phone.trim() === "") {
			// 	this.__errors.phone = true;
			// 	this.__isValid = false;
			// }
		}

		if (mode === "setNewPassword") {
			if (this.password.trim().length < 6) {
				errors.push("La password deve essere lunga almeno 6 caratteri.");
				this.__errors.password = true;
				this.__isValid = false;
			}
			if (this.__passwordConfirm.trim() === "" || this.password.trim() !== this.__passwordConfirm.trim()) {
				errors.push("La password di verifica non corrisponde.");
				this.__errors.passwordConfirm = true;
				this.__isValid = false;
			}
		}

		return errors;
	}
}

Shark.registerModel("User", User);

export default User;